import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederBarnestipendDto from '../Models/VeilederBarnestipendDto';
import { connect } from 'react-redux';
import { VeilederBarnestipendAppState } from '../Store';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { BarnestipendSatser } from '../Utilities/BarnestipendApi';
import resultatVariabler from '../Utilities/ResultatVariabler';
import { BoksC1 } from '../Models/Ids';

import ResultatComponent from './ResultatComponent';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';
import { ResultatSectionComponent } from './ResultatSectionComponent';

interface C2ResultOwnProps {
    eventId: string | null;
}

type C2ResultatProps = MapStateToProps & MapDispatchToProps & C2ResultOwnProps;

class C2ResultatComponent extends React.PureComponent<C2ResultatProps> {
    constructor(props: C2ResultatProps) {
        super(props);
    }

    render(): JSX.Element | null {
        const { epiContext, satser, locale, eventId } = this.props;
        if (satser === null) {
            return null;
        }

        const ar = satser.Ar.toString();

        const inntektEgen = tilPengerFormat(satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X, locale);

        const trygdGrense = tilPengerFormat(satser.SATS_ST04_TRYGDEGRENSE_DAGER_211_X, locale);

        return (
            <ResultatComponent
                boksId={BoksC1}
                tittelInntekt="resultatAleneC2InntektsgrenserTittel"
                tittelFormueTrygd="resultatAleneC2GrenseTrygdTittel"
                tittelKontroll="resultatAleneC2KontrollInntektTittel"
                innholdInntekt={
                    <ResultatSectionComponent
                        ar={ar}
                        epiContext={epiContext}
                        verdi={inntektEgen}
                        tekst="resultatAleneC2InntektsgrenserBrodtekst"
                    />
                }
                innholdFormueTrygd={
                    <ResultatSectionComponent
                        ar={ar}
                        epiContext={epiContext}
                        verdi={trygdGrense}
                        tekst="resultatAleneC2GrenseTrygdBrodtekstOver"
                        underElement={<p>{contentResolver(epiContext, 'resultatAleneC2GrenseTrygdBrodtekstUnder')}</p>}
                    />
                }
                innholdKontroll={contentResolver(
                    epiContext,
                    'resultatAleneC2KontrollInntektBrodtekst',
                    undefined,
                    resultatVariabler(satser, locale),
                )}
                eventId={eventId}
            />
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederBarnestipendDto>;
    satser: BarnestipendSatser | null;
    locale: string;
}

interface MapDispatchToProps {}

export default connect(
    (state: VeilederBarnestipendAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            satser: state.satser,
            locale: state.epiContext.locale,
        };
    },
)(C2ResultatComponent);
